<!--<app-ctl-spinning-loader [isLoading]="loaded"></app-ctl-spinning-loader>-->
<div *ngIf="mySubjectsList?.length && this.myForm"  [dir]="textDir">
   <div class="top-header-sm head-hgt">
    <label class=" form-title">{{this.data?.name}}</label>
    <label class=" label-light">{{schoolName}}</label>

    </div>
    <div class="white" [ngClass]="viewType=='edit'?'form-dim2':'form-dim1'" [dir]="textDir">
        <!-- <div *ngIf="viewType=='edit'" style="margin-top: 4px; margin-bottom: 15px;">
            <label class="marL10 label-light">Edit Classes and Subjects for this Grade.</label>
        </div> -->
        
        <form [formGroup]="this.myForm">
            <div class="form-inline flexStart marT15">
                <label class="labelwid label-light" >{{'Classes' | translate }}</label>
                <label  class="labeltxt">
                    <ng-container *ngIf="viewType=='read'">
                        
                        <!-- <ul *ngIf="data && data.classes && data.classes!==undefined" style="list-style-type: none;margin: 0; padding: 0;">
                            <li *ngFor="let item of data?.classes?.split(',') let i = index" style="padding-bottom: 8px">
                            {{item|ucwords}}
                            </li>
                        </ul> -->
                        <ul *ngFor="let item of data?.objclasses let i = index" style="list-style-type: none;margin: 0; padding: 0;">
                            <li class="no-pad padB5" >
                                <label class="labeltxt">{{item?.name|ucwords}}</label>
                            </li>
                        </ul>
                    </ng-container>
                    <!-- <ng-container *ngIf="viewType=='edit'">
                        <input *ngIf="data && data.classes && data.classes!==undefined" #sclass formControlName="classes" style="width: 280px;" type="text" [value]="data?.classes" class="form-control" placeholder="Enter comma separated class name" />
                        <input *ngIf="data && data.classes && data.classes==undefined" #sclass formControlName="classes" style="width: 280px;" type="text"  class="form-control" placeholder="Enter comma separated class name" />
                    </ng-container> -->
                    <div *ngIf="viewType=='edit'" formArrayName="classes">
                        <ul style="list-style-type: none;margin: 0; padding: 0;">
                            <li class="padB5" *ngFor="let clsub of this.myForm.controls?.classes?.controls; let i = index; trackBy:trackByFn">
                                <div [formGroupName]="i" *ngIf="this.row[i]==true">
                                    <input formControlName="_id" type="hidden">
                                    <input #inputClass formControlName="name" id="{{i}}" type="text" class="inp-txt-wid form-control" placeholder="{{'Enter class name' | translate}}" (keypress)="generateBlankItemIndex($event)" [dir]="textDir"/>
                                    <span style="cursor: pointer;" [ngClass]="textDir=='rtl'?'marR5':'marL5'">
                                        <a (click)='removeClass(i,clsub?.value)' class="dot-link-txt edit" *ngIf="blankItemIndex >= 1">{{'Remove' | translate}}</a>
                                            
                                        
                                    </span>
                                </div>
                            </li>
                        </ul>
                        <div style="margin-top: 8px;" *ngIf="blankItemIndex < 10">
                            <button class="btn primary add-new-btn" (click)="addNewClass(blankItemIndex)">{{'Add a class' | translate}}</button>
                        </div>
                        
                    </div>
                </label>
               <!--  <ng-container *ngIf="viewType=='read'">
                <span class="pull-right" style="margin-right: 23px;">
                    <a (click)="edit()" class="edit">
                        <i class="glyphicon glyphicon-pencil"></i>
                        &nbsp;&nbsp;Edit Grade
                    </a>
                </span>
                </ng-container> -->
            </div>
            <div class="marT15 flexStart">
                <label class="labelwid label-light" >{{'Students' | translate}}</label>
               <label class="labeltxt">{{this.data?.studentCount}}</label>
            </div>
            <div class="margTop flexStart padB30">
                <label class="labelwid label-light" >{{'Subjects' | translate}}</label>
                <ng-container *ngIf="viewType=='read'">
                    <!--<span>{{data?.subjects}}</span>-->
                    <label >
                        <ul style="list-style-type: none;margin: 0; padding: 0;">
                            <li *ngFor="let item of data?.subjects?.split(',') let i = index" style="padding: 0px">
				                <label class="labeltxt">{{item|ucwords}}</label>
			                </li>
                        </ul>
                    </label>
                </ng-container>
                <ng-container *ngIf="viewType=='edit'">
                    <div class="slist">
                        <div *ngFor="let item of mySubjectsList let i = index">
                            <div class="checkbox">
                               <!--  <label class="labeltxt">
                                    <input type="checkbox" [checked]="isChecked(item)" (change)="checkUncheckSubject(item,$event)">
					                {{item.name | ucfirst}}
                                </label> -->
                                
                                <input type="checkbox" id="{{'cd'+i}}" [checked]="isChecked(item)" (change)="checkUncheckSubject(item,$event)">
                                <label class="labeltxt padB10" for="{{'cd'+i}}">{{item.name | ucfirst}}</label>
                            </div>
                        </div>
                    </div>
                </ng-container>
                
            </div>

           <!--  <ng-container *ngIf="viewType=='edit' && loggedInUser?.role?.name!=='ProjectAdmin'">
                <div style="font-size:10px;margin-top:10px; margin-left:10px;color:#666666;padding-right: 20px; text-align: justify;"><span class="glyphicon glyphicon-info-sign" style="margin-right: 3px;font-size: 11px; color:#999999"></span>When removing a Class, any assigned Students will automatically become archived. 
                    Re-assignment and re-activation must be completed manually.
                    </div>
                <div style="font-size:10px;margin-top:10px; margin-left:10px;color:#666666;padding-right: 20px;"><span class="glyphicon glyphicon-info-sign" style="margin-right: 3px;font-size: 11px; color:#999999"></span>To add a subject not listed here, please place a request with the Project Administrator</div>
            </ng-container> -->

        </form>
    </div>
</div>
<!-- <lib-ctl-confirm-modal
    modalID ="errorModal"
  [titleMessage]=this.titleMessage
  [subTitleMessage]=this.subTitleMessage
  [detailMessage]=this.detailMessage
  [listMessage]=this.listMessage
  (confirm)="removeClassConfirm()">
</lib-ctl-confirm-modal> -->